import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profile } from '@myap/ui-library'
import { deleteRequest } from '../utils/fetchOperations'
import { SCORE_SEND_KEY } from '../components/_common/reactquery'

const useDeleteStudentScoreSendMutation = ({ educationPeriodCd }) => {
  const queryClient = useQueryClient()
  const { apiUrl } = profile()
  return useMutation({
    mutationKey: [SCORE_SEND_KEY, educationPeriodCd],
    mutationFn: async ({ signal }) => {
      return await deleteRequest({
        url: `${apiUrl}/score-send-di/education-periods/${educationPeriodCd}`,
        signal,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SCORE_SEND_KEY] })
    },
  })
}

export default useDeleteStudentScoreSendMutation
